// import consts from "@/consts.js";
import Request from './request';
import store from '@/store.js';
import i18n from '@/i18n'
import snackbar from '@/plugins/snackbar'


async function fetch(data) {
    return Request('get', "api/qacenter/index", data);
}

async function complete(id){
    return Request('get',"api/qacenter/complete/" + id)
}

async function edit(id,data){
    return Request('get',"api/qacenter/edit/" + id,data)
}

async function batchComplete(data){
    return Request('get',"api/qacenter/batch-complete/",data)
}

async function batchRequest(data){
    return Request('get',"api/qacenter/batch-request/",data)
}

async function fetchOne(id){
    return Request('get',"api/qacenter/view?id=" + id)
}

async function submit(data){
    return Request('patch',"api/qacenter/answer/", data)
}


async function tree() {
    const response = await Request('get', "api/qacenter-categories/tree");
    if (response.data && response.data.status.isOK()) {
      store.commit("serverDistricts", response.data.qacenter_categories);
    }
    return response;
}
  
// 导出
async function exports(data) {
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/qacenter/export', data)
    if (response.data && response.data.status.isOK()) {
      snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}
  

export default {
    fetch, 
    tree,
    complete,
    edit,
    batchComplete,
    fetchOne,
    submit,
    batchRequest,
    exports
};